import React from 'react';
import FooterStyles from './styles/FooterStyles';

const Footer = () => {
  return (
    <FooterStyles>
      <a href="https://github.com/SSundstrom/Musiquiz/issues" target="blank">
        Found an issue? Submit it here.
      </a>
    </FooterStyles>
  );
};

export default Footer;
